// extracted by mini-css-extract-plugin
export default {"inputWrapper":"a437o1","button":"b437o1","plusButton":"c437o1","minusButton":"d437o1"};